/* Crea tu pack · VeraBelleza
   Carrusel coverflow (índice activo) + resumen del pack. Añade todas las piezas con UNA llamada a VB.cart.add:
   las piezas llevan properties {_pack: id del pack} (contrato §5 de la guía); la misma variante del mismo pack va en UNA
   línea con cantidad N (QA 5a: antes _pieza la partía en varias líneas). El código de
   descuento lo calcula y aplica VB.cart.syncPacks (listener global de vb.js), no esta sección. */
(() => {
  if (customElements.get('vb-pack-builder')) return;
  const money = (c) => (window.VB && VB.formatMoney ? VB.formatMoney(c) : (c / 100).toFixed(2).replace('.', ',') + '€');
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  const ICON_X = '<svg class="vb-ico" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M6.75781 17.2431L12.0008 12.0001L17.2438 17.2431M17.2438 6.75708L11.9998 12.0001L6.75781 6.75708" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  class VBPackBuilder extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      try { this.cfg = JSON.parse(this.querySelector('[data-pk-config]').textContent); } catch (e) { return; }
      this.previewDiscount();
      this.slides = [...this.querySelectorAll('[data-pk-slide]')];
      this.track = this.querySelector('[data-pk-track]');
      this.emptyTpl = [...this.querySelectorAll('[data-pk-slots] > li')].map((li) => li.innerHTML);
      this.items = [];
      this.active = Math.min(Math.max(this.cfg.start || 0, 0), Math.max(this.slides.length - 1, 0));
      if (this.cfg.prefill && this.cfg.prefillData) {
        const d = this.cfg.prefillData;
        const own = this.querySelector('[data-pk-slide][data-self]');
        this.prefill = { id: this.cfg.prefill, name: (own && own.dataset.name) || d.name, price: d.price, img: (own && own.dataset.img) || d.img, self: true };
        this.items.push({ ...this.prefill });
      }
      this.addEventListener('click', (e) => this.onClick(e));
      // Móvil por pasos: 1 · elegir (carrusel + barra mini) → 2 · tu pack (resumen y pago)
      this.step = 1;
      this.mq = window.matchMedia('(max-width: 749px)');
      const onMq = () => {
        const on = this.mq.matches;
        this.instant = true; // móvil y ordenador (Nicolas 28-oct): cada «Añadir al pack» va directo al carrito
        this.classList.toggle('vb-pack--steps', on);
        this.querySelectorAll('[data-pk-mini]').forEach((el) => { el.hidden = !on; });
        this.querySelectorAll('[data-pk-steps], .vb-pack__back').forEach((el) => { el.hidden = true; });
        this.setStep(1, false);
        this.restore();
      };
      onMq();
      if (this.mq.addEventListener) this.mq.addEventListener('change', onMq);
      this.bindDrag();
      this.layout();
      this.render();
    }

    /* ---------- vista previa del descuento ----------
       Sin niveles reales y en un tema sin publicar (preview / editor; mismo criterio que «Enlaces de QA» de assets/vb.js):
       niveles de «vista previa», textos con descuento, DESCUENTO y total, (los cobra VB.cart.syncPacks con códigos). Publicado
       (role main) no cambia nada. El carrito sigue recibiendo las mismas líneas con _pack. */
    previewDiscount() {
      const { cfg } = this;
      const role = window.Shopify && Shopify.theme && Shopify.theme.role;
      if (cfg.discount || !role || role === 'main' || !(cfg.previewTiers || []).length) return;
      cfg.tiers = cfg.previewTiers;
      cfg.discount = true;
      this.classList.add('vb-pack--discount', 'vb-pack--preview');
      const lv = this.querySelector('[data-pk-levels]'); if (lv) lv.hidden = false;
      const h = this.querySelector('.vb-pack__title'); if (h && cfg.headingPrev) { h.innerHTML = cfg.headingPrev; h.hidden = false; }
      const p = this.querySelector('.vb-pack__text'); if (p && cfg.introPrev) p.innerHTML = cfg.introPrev;
    }

    /* ---------- carrusel ---------- */
    /* Cíclico como el prototipo del equipo de diseño: el anterior del primero es el último */
    go(i) {
      const n = this.slides.length;
      if (!n) return;
      this.active = ((i % n) + n) % n;
      this.layout();
    }
    layout() {
      const n = this.slides.length;
      const half = Math.floor(n / 2);
      this.slides.forEach((s, i) => {
        const o = ((((i - this.active) % n) + n + half) % n) - half;
        s.style.setProperty('--o', o);
        s.classList.toggle('is-active', o === 0);
        s.classList.toggle('is-far', Math.abs(o) > 1);
        if (o === 0) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        const b = s.querySelector('[data-pk-add]');
        if (b) b.tabIndex = o === 0 ? 0 : -1;
      });
      const bar = this.querySelector('[data-pk-progress]');
      if (bar) bar.style.width = n ? ((this.active + 1) / n) * 100 + '%' : '0';
      this.syncAddButton();
    }
    bindDrag() {
      const t = this.track;
      if (!t) return;
      let x0 = null, y0 = 0, moved = false;
      t.addEventListener('pointerdown', (e) => { if (e.button !== 0) return; x0 = e.clientX; y0 = e.clientY; moved = false; });
      t.addEventListener('pointermove', (e) => {
        if (x0 === null) return;
        if (!moved && Math.abs(e.clientX - x0) > 8 && Math.abs(e.clientX - x0) > Math.abs(e.clientY - y0)) moved = true;
      });
      const end = (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        x0 = null;
        if (moved && Math.abs(dx) > 40) { this._swiped = true; this.go(this.active + (dx < 0 ? 1 : -1)); setTimeout(() => { this._swiped = false; }, 50); }
      };
      t.addEventListener('pointerup', end);
      t.addEventListener('pointercancel', () => { x0 = null; });
      t.addEventListener('dragstart', (e) => e.preventDefault());
    }

    /* ---------- estado del pack ---------- */
    /* ---------- móvil: pack directo al carrito ----------
       Un id de pack por sesión (sessionStorage) para que todas las piezas compartan _pack y syncPacks aplique el nivel.
       Al cargar se recuperan del carrito las piezas de ese pack (con su key, para poder quitarlas desde aquí). */
    packId() {
      let id = null;
      try { id = sessionStorage.getItem('vb:pk-live'); } catch (e) { /* sin almacenamiento */ }
      if (!id) { id = 'pk-' + uid(); try { sessionStorage.setItem('vb:pk-live', id); } catch (e) { /* idem */ } }
      return id;
    }
    async restore() {
      if (this._restored) return;
      this._restored = true;
      const routesCart = (window.VB && VB.routes && VB.routes.cart) || '/cart';
      const cart = await fetch(`${routesCart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);
      if (!cart) return;
      const id = this.packId();
      const mine = cart.items.filter((it) => it.properties && it.properties._pack === id);
      if (!mine.length) return;
      const pending = this.items.filter((it) => !it.key && !mine.some((m) => m.variant_id === it.id));
      // una línea con cantidad N = N huecos (la misma variante del pack va fusionada en una sola línea)
      let selfDone = false;
      this.items = [...mine.flatMap((m) => Array.from({ length: m.quantity }, () => {
        const self = !selfDone && !!this.prefill && m.variant_id === this.prefill.id;
        if (self) selfDone = true;
        return { id: m.variant_id, name: m.product_title, price: m.price, img: m.image, key: m.key, self };
      })), ...pending].slice(0, this.cfg.max);
      this.render();
    }
    async syncCart() {
      const routesCart = (window.VB && VB.routes && VB.routes.cart) || '/cart';
      const cart = await fetch(`${routesCart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);
      if (cart && VB.cart.syncPacks) await VB.cart.syncPacks(cart).catch(() => {});
    }
    async addInstant(s) {
      const it = { id: +s.dataset.variant, name: s.dataset.name, price: +s.dataset.price, img: s.dataset.img };
      const pending = this.items.filter((x) => !x.key); // la pieza de la ficha («ya está en tu pack») aún no está en el carrito
      this.items.push(it);
      this._new = this.items.length - 1;
      this.render();
      const pack = this.packId();
      const toAdd = [...pending, it];
      const btn = s.querySelector('[data-pk-add]');
      btn?.classList.add('is-loading');
      try {
        // solo _pack: Shopify fusiona la misma variante del mismo pack en una línea (cantidad +1) en vez de abrir otra
        const data = await VB.cart.add(this.group(toAdd, pack), { open: false });
        const lines = (data && data.items) || [];
        toAdd.forEach((x) => { const l = lines.find((m) => m.variant_id === x.id); if (l) x.key = l.key; });
        // VB.cart.add ya aplica el código del pack antes de pintar (no hace falta otra vuelta a /cart.js)
        this.flash(this.cfg.t.addedCart);
      } catch (e) {
        this.items.splice(this.items.indexOf(it), 1);
        this.flash((e && e.message) || this.cfg.t.error, true);
      } finally {
        btn?.classList.remove('is-loading');
        this.render();
      }
    }
    async removeInstant(i) {
      const it = this.items[i];
      if (!it) return;
      this.items.splice(i, 1);
      this.render();
      if (!it.key) return;
      const routes = (window.VB && VB.routes) || {};
      try {
        // la key de la línea cambia cuando Shopify aplica el código del pack → se busca la línea por variante + _pack
        const cart = await fetch(`${routes.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const pack = this.packId();
        const line = cart.items.find((m) => m.variant_id === it.id && m.properties && m.properties._pack === pack);
        if (!line) return;
        await fetch(`${routes.cartChange || '/cart/change'}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity - 1 }) });
        if (VB.cart.refresh) await VB.cart.refresh();
        await this.syncCart();
      } catch (e) { /* la línea ya no existe: nada que hacer */ }
    }
    /* piezas → líneas del carrito: una por variante con cantidad = nº de piezas de esa variante, todas con el mismo _pack */
    group(list, pack) {
      const by = new Map();
      list.forEach((x) => { const g = by.get(x.id); if (g) g.quantity += 1; else by.set(x.id, { id: x.id, quantity: 1, properties: { _pack: pack } }); });
      return [...by.values()];
    }
    flash(msg, isErr) {
      // aviso sobre la barra de móvil o, en ordenador, sobre el resumen (ajustes «Aviso Añadido» y «Check animado»; los errores siempre)
      if (!isErr && this.cfg.toast === false) return;
      const m = [this.querySelector('.vb-pack__mini'), this.querySelector('[data-pk-summary]')].find((x) => x && x.getClientRects().length);
      if (!m) return;
      let t = m.querySelector('.vb-pack__toast');
      if (!t) { t = document.createElement('p'); t.className = 'vb-pack__toast'; t.setAttribute('role', 'status'); m.appendChild(t); }
      t.textContent = msg;
      if (!isErr && this.cfg.toastIcon !== false) t.insertAdjacentHTML('afterbegin', '<svg class="vb-pack__toast-ic" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8"/><path d="M4.6 8.3l2.2 2.2 4.6-4.8"/></svg>');
      t.classList.toggle('is-err', !!isErr);
      t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
      clearTimeout(this._toastT); this._toastT = setTimeout(() => t.classList.remove('is-on'), 2200);
    }
    setStep(n, scroll = true) {
      this.step = n;
      this.classList.toggle('is-step2', n === 2);
      this.querySelectorAll('[data-pk-steps] [data-pk-step]').forEach((b) => {
        const on = Number(b.dataset.pkStep) === n;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', String(on));
      });
      if (scroll && this.classList.contains('vb-pack--steps')) {
        const top = this.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 80, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
    onClick(e) {
      if (this._swiped) return;
      const t = e.target;
      if (t.closest('[data-pk-go-cart]')) { if (VB.cart.refresh) VB.cart.refresh().catch(() => {}).then(() => VB.cart.open && VB.cart.open()); return; }
      const mr = t.closest('[data-pk-mini-remove]');
      if (mr) return this.removeInstant(+mr.dataset.pkMiniRemove);
      const st = t.closest('[data-pk-step]');
      if (st) return this.setStep(Number(st.dataset.pkStep));
      if (t.closest('[data-pk-prev]')) return this.go(this.active - 1);
      if (t.closest('[data-pk-next]')) return this.go(this.active + 1);
      const go = t.closest('[data-pk-go]');
      if (go) {
        const i = this.slides.indexOf(go.closest('[data-pk-slide]'));
        if (i > -1 && i !== this.active) return this.go(i);
      }
      if (t.closest('[data-pk-add]')) return this.addActive();
      const rm = t.closest('[data-pk-remove]');
      if (rm) return this.instant ? this.removeInstant(+rm.dataset.pkRemove) : this.remove(+rm.dataset.pkRemove);
      if (t.closest('[data-pk-empty]')) {
        const b = this.slides[this.active]?.querySelector('[data-pk-add]');
        if (b) { b.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); b.focus({ preventScroll: true }); }
        return;
      }
      if (t.closest('[data-pk-cta]')) {
        if (this.instant) { if (VB.cart.refresh) VB.cart.refresh().catch(() => {}).then(() => VB.cart.open && VB.cart.open()); return; }
        return this.submit();
      }
    }
    addActive() {
      const s = this.slides[this.active];
      if (!s || s.dataset.available !== 'true' || this.items.length >= this.cfg.max) return;
      if (this.instant && window.VB && VB.cart && VB.cart.add) {
        this.addInstant(s);
        if (this.items.length < this.cfg.max) this.go(this.active + 1);
        return;
      }
      this.items.push({ id: +s.dataset.variant, name: s.dataset.name, price: +s.dataset.price, img: s.dataset.img });
      this._new = this.items.length - 1;
      this.render();
      // tras añadir, el carrusel pasa al siguiente producto para seguir completando
      const hadFocus = s.contains(document.activeElement); if (this.items.length < this.cfg.max) { this.go(this.active + 1); if (hadFocus) this.slides[this.active].querySelector('[data-pk-add]')?.focus({ preventScroll: true }); } else if (hadFocus) this.querySelector('[data-pk-cta]')?.focus({ preventScroll: true });
    }
    remove(i) {
      this.items.splice(i, 1);
      this._new = -1;
      this.render();
      this.querySelector('[data-pk-slots] button')?.focus({ preventScroll: true });
    }
    /* % del nivel alcanzado con n piezas: niveles[0] desde el mínimo, niveles[1] desde mínimo+1… (2→5, 3→10, 4→15) */
    pct(n) {
      const t = this.cfg.tiers || [];
      const k = Math.min(n, this.cfg.max) - this.cfg.min;
      return k >= 0 && t.length ? Number(t[Math.min(k, t.length - 1)]) || 0 : 0;
    }
    /* % que desbloquea el hueco i (0-based) de los niveles reales: hueco del mínimo → niveles[0], siguiente → niveles[1]…;
       0 = el hueco no desbloquea nada (antes del mínimo, sin descuento o más huecos que niveles) */
    slotTier(i) {
      const t = this.cfg.tiers || [];
      const k = i + 1 - this.cfg.min;
      return this.cfg.discount && k >= 0 && k < t.length ? Number(t[k]) || 0 : 0;
    }
    nProducts(n) { return n === 1 ? this.cfg.t.one : this.cfg.t.many.replace('[n]', n); }
    syncAddButton() {
      const full = this.items.length >= this.cfg.max;
      this.slides.forEach((s) => {
        const b = s.querySelector('[data-pk-add]');
        if (!b) return;
        const ok = s.dataset.available === 'true';
        b.disabled = !ok || full;
        b.textContent = !ok ? this.cfg.t.soldout : full ? this.cfg.t.added : this.cfg.t.add;
      });
    }
    render() {
      const { cfg } = this;
      const n = this.items.length;
      const T = cfg.t;
      // mensaje
      let msg;
      const strong = (k) => `<strong>${esc(this.nProducts(k))}</strong>`;
      if (cfg.discount) {
        if (n >= cfg.max) msg = T.maxDiscount.replace('[p]', this.pct(n));
        else {
          const target = Math.max(n + 1, cfg.min);
          msg = (target - n === 1 ? T.needDiscountOne : T.needDiscount).replace('[n]', strong(target - n)).replace('[p]', this.pct(target));
        }
      } else if (n < cfg.min) msg = (cfg.min - n === 1 ? T.needOne : T.need).replace('[n]', strong(cfg.min - n));
      else if (n < cfg.max) msg = T.ready.replace('[n]', strong(cfg.max - n));
      else msg = T.full;
      this.querySelector('[data-pk-msg]').innerHTML = msg;
      const mm = this.querySelector('[data-pk-mini-msg]'); if (mm) mm.innerHTML = msg;
      this.querySelectorAll('[data-pk-mini-n]').forEach((x) => { x.textContent = this.items.filter((x2) => x2.key).length; });
      const mt = this.querySelector('[data-pk-mini-thumbs]');
      if (mt) {
        mt.innerHTML = Array.from({ length: cfg.max }, (_, i) => {
          const it = this.items[i];
          const tp = this.slotTier(i);
          if (!it) return `<li class="vb-pack__mini-slot is-empty" aria-hidden="true">${tp ? `<span class="vb-pack__mini-tier">−${tp}%</span>` : ''}</li>`;
          return `<li class="vb-pack__mini-slot${i === this._new ? ' is-new' : ''}">${it.img ? `<img src="${esc(it.img)}" alt="${esc(it.name)}" width="40" height="40">` : ''}${tp ? `<span class="vb-pack__mini-tier is-on" aria-hidden="true">−${tp}%</span>` : ''}<button type="button" class="vb-pack__mini-x" data-pk-mini-remove="${i}" aria-label="${esc(T.remove.replace('[producto]', it.name))}">${ICON_X}</button></li>`;
        }).join('');
      }
      const mbar = this.querySelector('[data-pk-mini-bar]'); if (mbar) mbar.style.width = Math.min(100, (n / cfg.max) * 100) + '%';
      const go = this.querySelector('[data-pk-go-cart]'); if (go) go.disabled = !this.items.some((x) => x.key);
      const sn = this.querySelector('[data-pk-step-n]'); if (sn) sn.textContent = n ? `(${n})` : '';
      const mb = this.querySelector('.vb-pack__mini'); if (mb) { mb.classList.toggle('is-ready', n >= cfg.min); if (n !== this._lastN && n > (this._lastN || 0)) { mb.classList.remove('is-bump'); void mb.offsetWidth; mb.classList.add('is-bump'); } }
      this._lastN = n;

      // barra de niveles: n < mínimo → proporcional hasta casi el primer nivel; luego centro de cada nivel; lleno = 100 %
      const tiers = this.querySelectorAll('[data-pk-tier]');
      const L = tiers.length || 1;
      let w;
      if (n >= cfg.max) w = 100;
      else if (n < cfg.min) w = (0.5 / L) * 100 * 0.95 * (n / cfg.min); // Figma: 1 de 2 → 28/352 (47,5 % del primer nivel)
      else w = ((n - cfg.min + 0.5) / L) * 100;
      const bar = this.querySelector('[data-pk-bar]');
      if (bar) bar.style.width = Math.min(w, 100) + '%';
      this.querySelectorAll('[data-pk-dot]').forEach((d, i) => d.classList.toggle('is-on', n >= cfg.min + i));
      tiers.forEach((d, i) => d.classList.toggle('is-on', n >= cfg.min + i));

      const cnt = this.querySelector('[data-pk-count]'); if (cnt) cnt.textContent = this.nProducts(n);

      // huecos (precio por pieza con el % del nivel alcanzado)
      const d = cfg.discount ? this.pct(n) : 0;
      // El descuento total se trunca sobre la suma (como el código VBPACK) y se REPARTE entre las piezas céntimo a
      // céntimo: así los precios de los huecos suman exactamente el TOTAL (antes 2 × 28,49 ≠ 56,99)
      const sumAll = this.items.reduce((a, it) => a + it.price, 0);
      const discAll = n >= cfg.min && sumAll ? Math.floor((sumAll * d) / 100) : 0;
      const alloc = this.items.map((it) => (sumAll ? Math.floor((it.price * discAll) / sumAll) : 0));
      for (let r = discAll - alloc.reduce((a, v) => a + v, 0), j = 0; r > 0 && alloc.length; r--, j = (j + 1) % alloc.length) alloc[j] += 1;
      const slots = this.querySelector('[data-pk-slots]');
      slots.innerHTML = this.emptyTpl.map((tpl, i) => {
        const it = this.items[i];
        if (!it) return `<li class="vb-pack__slot">${tpl}</li>`;
        const label = T.remove.replace('[producto]', it.name);
        return `<li class="vb-pack__slot${i === this._new ? ' is-new' : ''}"><div class="vb-pack__thumb">${it.img ? `<img src="${esc(it.img)}" alt="${esc(it.name)}" width="120" height="120" loading="lazy">` : ''}${it.self && T.self ? `<span class="vb-pack__self">${esc(T.self)}</span>` : ''}<button type="button" class="vb-pack__remove" data-pk-remove="${i}" aria-label="${esc(label)}">${ICON_X}</button></div><p class="vb-pack__slot-price">${money(it.price - (alloc[i] || 0))}</p></li>`;
      }).join('');
      this._new = -1;

      // totales
      const sum = this.items.reduce((a, it) => a + it.price, 0);
      // Como el código VBPACK de Shopify: el % se trunca al céntimo sobre la suma (59,98 −5 % = 56,99)
      const disc = n >= cfg.min ? Math.floor((sum * d) / 100) : 0;
      this.querySelector('[data-pk-discount]').textContent = money(disc);
      this.querySelector('[data-pk-total]').textContent = money(sum - disc);
      const cta = this.querySelector('[data-pk-cta]');
      if (this.instant) {
        // ya está en el carrito: el botón del resumen lleva al carrito (con lo que haya del pack)
        cta.disabled = !this.items.some((x) => x.key);
        if (cfg.t.goCart && cta.textContent !== cfg.t.goCart) cta.textContent = cfg.t.goCart;
      } else cta.disabled = n < cfg.min;
      this.syncAddButton();
    }

    async submit() {
      const { cfg } = this;
      if (this.items.length < cfg.min || this._busy) return;
      const err = this.querySelector('[data-pk-error]');
      const cta = this.querySelector('[data-pk-cta]');
      err.hidden = true;
      this._busy = true;
      cta.classList.add('is-loading');
      const pack = uid();
      const items = this.group(this.items, pack);
      try {
        if (!window.VB || !VB.cart || !VB.cart.add) throw new Error(cfg.t.error);
        await VB.cart.add(items);
        this.items = this.prefill ? [{ ...this.prefill }] : [];
        this.render();
      } catch (e) {
        err.textContent = (e && e.message) || cfg.t.error;
        err.hidden = false;
      } finally {
        this._busy = false;
        cta.classList.remove('is-loading');
      }
    }
  }
  customElements.define('vb-pack-builder', VBPackBuilder);
})();
